<template>
  <div class="mb-20">
    <label class="has-text-weight-bold has-text-grid-1 is-size-14px">
      Documents à télécharger
    </label>
    <button class="button is-fullwidth has-text-weight-bold mt-10 mb-10 is-rounded box-shadow-0"
      @click="getPdf()">
      <b-icon icon="file-pdf" type="is-default" class="mr-10"></b-icon>
      <span class="has-text-default">Recommandation PDF</span>
    </button>
    <button class="button is-fullwidth has-text-weight-bold mb-10 is-rounded box-shadow-0"
      @click="getRecapPdf()">
      <b-icon icon="file-pdf" type="is-default" class="mr-10"></b-icon>
      <span class="has-text-default">Récap budgétaire PDF</span>
    </button>
    <button class="button is-fullwidth has-text-weight-bold mb-10 is-rounded box-shadow-0"
      @click="exportExcel()">
      <b-icon icon="file-excel" type="is-default" class="mr-10"></b-icon>
      <span class="has-text-default">Récap budgétaire Excel</span>
    </button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { printAnonymeAsync, exportAnonymeAsync } from '@/api/edition';
import { dowloadFileAsync } from '@/services/general/general';
import gestionErreur from '@/services/general/gestionErreur';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
	computed: {
		...Recommandation.mapGetters({
			recom: 'recom',
		}),
	},
  methods: {
    async getPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const payload = {
					ids: [this.recom.id],
					extension: 'Pdf',
					typeDonnee: 'Opportunite',
				};
        await dowloadFileAsync(() => printAnonymeAsync(payload));
      } catch (error) {
        gestionErreur('Erreur lors de l\'export PDF de la recommandation', error);
      } finally {
       loadingComponent.close();
      }
    },
    async getRecapPdf() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const payload = {
					ids: [this.recom.id],
					extension: 'Pdf',
					typeDonnee: 'OpportuniteRecap',
					typeEdition: 'OpportuniteRecap',
				};
        await dowloadFileAsync(() => printAnonymeAsync(payload));
      } catch (error) {
        gestionErreur(`Erreur lors de l'export du récapitulatif budgétaire PDF de la recommandation`, error);
      } finally {
       loadingComponent.close();
      }
    },
    async exportExcel() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const payload = {
					ids: [this.recom.id],
					typeDonnee: 'opportunite',
					parametresAdditionnels: { id: this.recom.id }
				};
        await dowloadFileAsync(() => exportAnonymeAsync(payload));
      } catch (error) {
        gestionErreur(`Erreur lors de l'export excel de la recommandation`, error);
      } finally {
       loadingComponent.close();
      }
    },
  }
}
</script>

<style>

</style>